import { CLIENT_CONTRACT } from "./client_contract"

const SERVER_HEARTBEAT_REFRESH_WINDOW_SEC = CLIENT_CONTRACT.server.presence.heartbeatRefreshWindowMs / 1000
const TRACKING_INTERVAL_MAX_SEC = Math.max(5, SERVER_HEARTBEAT_REFRESH_WINDOW_SEC - 5)
const MOBILE_PRESENCE_POLICY = CLIENT_CONTRACT.mobile.presence

export const WEB_PRESENCE_POLICY = Object.freeze({
  minIntervalSec: CLIENT_CONTRACT.web.location.intervalMinSec,
  maxIntervalSec: CLIENT_CONTRACT.web.location.intervalMaxSec,
  serverHeartbeatRefreshWindowSec: SERVER_HEARTBEAT_REFRESH_WINDOW_SEC,
  trackingIntervalMaxSec: TRACKING_INTERVAL_MAX_SEC,
  offTripIntervalSec: TRACKING_INTERVAL_MAX_SEC,
  failureBackoffMaxSec: CLIENT_CONTRACT.web.location.intervalMaxSec,
  failureJitterRatio: 0.2,
  staleAfterMs: MOBILE_PRESENCE_POLICY.staleAfterMs,
  failuresBeforeStale: MOBILE_PRESENCE_POLICY.failuresBeforeStale
})
